import HomeHeroPremium from "../components/luxury/HomeHeroPremium";
import HomeValueStrip from "../components/luxury/HomeValueStrip";
import FeaturedProductsHome from "../components/luxury/FeaturedProductsHome";
import HomeMagneticStory from "../components/luxury/HomeMagneticStory";
import FeaturedCategoryCards from "../components/luxury/FeaturedCategoryCards";
import TestimonialsSlider from "../components/luxury/TestimonialsSlider";
import HomeSocialGallery from "../components/luxury/HomeSocialGallery";
import HomeCorporateCta from "../components/luxury/HomeCorporateCta";
import HomeTrustStrip from "../components/luxury/HomeTrustStrip";
import NewsletterLuxury from "../components/luxury/NewsletterLuxury";
import "../styles/home-landing.css";

/** Premium boutique gifting homepage — video banner hero and conversion sections. */
function Home({ addToCart }) {
  return (
    <div className="lux-home lux-home--landing">
      <HomeHeroPremium />
      <HomeValueStrip />
      <FeaturedProductsHome addToCart={addToCart} />
      <HomeMagneticStory />
      <FeaturedCategoryCards />
      <TestimonialsSlider />
      <HomeSocialGallery />
      <HomeCorporateCta />
      <NewsletterLuxury />
      <HomeTrustStrip />
    </div>
  );
}

export default Home;
